import React, { useEffect, useState } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { authenticationActions } from '../../../_actions/authentication.actions';
import { clientActions } from '../../../_actions/client.actions';
import { clientService } from '../../../_services/client.service';

import { providerService } from '../../../_services/provider.service'

export default function ProviderOptions() {
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  const [client, setClient] = useState({});

  const currentClient = useSelector(state => state.client)
  const authToken = useSelector(state => state.authentication.token);

  useEffect(() => {
    providerService.getOptions()
      .then(data => setOptions(data))
  }, []);

  useEffect(() => {
    setClient(currentClient);
  }, [currentClient])

  return <NavDropdown title={client.name || ''} className="user-dropdown">
    { options.filter(option => {
      return option.providerId !== client.id
    })
    .map(option => {
        return <NavDropdown.Item
          key={option.providerId}
          onClick={() => {
            clientService.getInfo(authToken, option.providerId)
              .then(data => {    
                dispatch(authenticationActions.clearAll())
                
                window.location.href = `https://${data.client.accountDomain}/login/refresh?auth=${authToken}&clientId=${option.providerId}`;
              })
          }}
          className='py-2'
        >{ option.name }</NavDropdown.Item>
      })
    }
  </NavDropdown>
}